module.exports = __webpack_public_path__ + "static/media/welcomeimage2.5f8c23bb.png";